/* eslint-disable prefer-template */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import 'typeface-roboto';
import NumberFormat from 'react-number-format';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 4,
  },
  image: {
    width: 80,
    height: 80,
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    minWidth: 80,
    minHeight: 80,
    borderRadius: 10,
  },
  detail: {
    flex: 1,
  },
  title: {
    color: theme.palette.primary.main,
  },
  infoWrapper: {
    height: '100%',
  },
  priceWrapper: {
    height: '100%',
  },
  discount: {
    position: 'absolute',
    top: 10,
    backgroundColor: 'red',
    padding: 5,
    color: 'white',
    borderRadius: 20,
    minWidth: 50,
    textAlign: 'center',
    boxShadow: '1px 3px 1px #9E9E9E',
    fontWeight: 'bold',
  },
}));

const OlsOrderRow = (props) => {
  const classes = useStyles();
  const { data, onOpen } = props;

  return (
    <div className={classes.root}>
      <Card onClick={() => onOpen(data)}>
        <CardActionArea>
          <CardContent>
            <Grid container spacing={2} justify="space-between">
              <Grid item className={classes.detail}>
                <Grid item container className={classes.infoWrapper} direction="column" justify="center" alignItems="flex-start">
                  <Grid item>
                    <Typography className={classes.title} variant="h5">
                      {data.order_number}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2">
                      {data.order_datetime}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid item container className={classes.priceWrapper} direction="column" justify="center" alignItems="flex-end">
                  <Grid item>
                    <Typography style={data.order_status === 'REJECTED' ? { color: 'red', fontWeight: 'bold', textDecoration: 'line-through' } : {}} variant="h6">
                      <NumberFormat value={data.order_total} isNumericString displayType="text" decimalScale={0} thousandSeparator="." decimalSeparator="," />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography style={data.order_step === 'INVOICE' ? { color: 'red', fontWeight: 'bold' } : {}} variant="body2">
                      {data.order_step}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
};

OlsOrderRow.defaultProps = {
  data: {
    order_uxid: '',
    order_version: '',
    order_account_uxid: '',
    order_from_type: '',
    order_from_uxid: '',
    order_number: '',
    order_name: '',
    order_courier_code: '',
    order_courier_name: '',
    order_courier_service: '',
    order_courier_description: '',
    order_store_name: '',
    order_store_province_id: '',
    order_store_province_name: '',
    order_store_city_id: '',
    order_store_city_name: '',
    order_store_city_type: '',
    order_store_subdistrict_id: '',
    order_store_subdistrict_name: '',
    order_shipping_realname: '',
    order_shipping_code: '',
    order_shipping_phone: '',
    order_shipping_company: '',
    order_shipping_email: '',
    order_shipping_address1: '',
    order_shipping_address2: '',
    order_shipping_address3: '',
    order_shipping_address4: '',
    order_shipping_address5: '',
    order_shipping_location_id: '',
    order_shipping_province_id: '',
    order_shipping_province_name: '',
    order_shipping_city_id: '',
    order_shipping_city_name: '',
    order_shipping_city_type: '',
    order_shipping_subdistrict_id: '',
    order_shipping_subdistrict_name: '',
    order_shipping_note: '',
    order_shipping_detail: '',
    order_shipping_cost: 0,
    order_weight: 0,
    order_value: 0,
    order_tax_percent: 0,
    order_tax_value: 0,
    order_discount_type: '',
    order_discount_value: 0,
    order_discount_price: 0,
    order_total: 0,
    order_profit: 0,
    order_uxcode: 0,
    order_cash_pay: 0,
    order_cash_change: 0,
    order_note: '',
    order_step: '',
    order_payment_status: '',
    order_expired_status: '',
    order_mutasi_uxid: '',
    order_status: '',
    order_timestamp: 0,
    order_datetime: '',
    order_expired_datetime: '',
  },
};

export default OlsOrderRow;
